import { useCallback } from 'react';
import config from '../config';

const useAuthFetch = () => {
  const authFetch = useCallback(async (endpoint, options = {}) => {
    const token = localStorage.getItem('jwtToken');
    
    const defaultHeaders = { 
      'Accept': 'application/json',
    };

    if (token) {
      defaultHeaders['Authorization'] = `Bearer ${token}`;
    }
 

    const response = await fetch(`${config.apiBaseUrl}${endpoint}`, {
      ...options,
      headers: {
        ...defaultHeaders, 
        ...options.headers,
      },
      credentials: 'include',
    });

    return response;
  }, []);

  return authFetch;
};

export default useAuthFetch; 